import { useOrgResolvedFlag } from './useOrgResolvedFlag';

/** PostHog flag key gating durable per-project custom-data layer visibility. */
export const CUSTOM_DATA_REMEMBER_VISIBILITY_FLAG = 'custom-data-remember-visibility';

/**
 * Whether custom-data layer visibility is remembered per project. Requires the flag to have
 * **resolved** for the active org, not merely to read ON: `useFeatureFlagEnabled` collapses
 * unresolved and off, and an org switch briefly reports the previous org's value. Anything short
 * of resolved ON keeps the older behaviour, where every layer defaults ON on each mount.
 */
export function useCustomDataRememberVisibility(): boolean {
  const { resolved, enabled } = useOrgResolvedFlag(CUSTOM_DATA_REMEMBER_VISIBILITY_FLAG);
  return resolved && enabled;
}
